import type { ComponentType } from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  type SignInPageProps,
} from '@backstage/plugin-app-react';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: () =>
          import('./sign-in.page').then(
            m => m.SignInPage as unknown as ComponentType<SignInPageProps>,
          ),
      },
    }),
  ],
});
